// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyDCSw6PdClcM_FDvp4iDo8Fb7Hdid9UBYs',
    authDomain: 'waiters-37a98.firebaseapp.com',
    projectId: 'waiters-37a98',
    storageBucket: 'waiters-37a98.appspot.com',
    messagingSenderId: '599517791753',
    appId: '1:599517791753:web:f591aa8430156bbd865ad8',
    measurementId: 'G-XFH7PEH04D',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
